export var IdTutorialFocusElement;
(function (IdTutorialFocusElement) {
    IdTutorialFocusElement["recipe_1"] = "recipe_1";
    IdTutorialFocusElement["button_start_production"] = "button_start_production";
    IdTutorialFocusElement["button_building_menu"] = "button_building_menu";
    IdTutorialFocusElement["button_building_buy"] = "button_building_buy";
    IdTutorialFocusElement["button_building_placement"] = "button_building_placement";
    IdTutorialFocusElement["hud_quest_7"] = "hud_quest_7";
    IdTutorialFocusElement["quest_show_me"] = "quest_show_me";
    IdTutorialFocusElement["quest_collect"] = "quest_collect";
    IdTutorialFocusElement["tutorial_background"] = "tutorial_background";
})(IdTutorialFocusElement || (IdTutorialFocusElement = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/IdTutorialFocusElement.ts
// module id = 122
// module chunks = 3